module.exports = __webpack_public_path__ + "static/media/c4.c60f3fda.png";